module.exports = __webpack_public_path__ + "img/loyalty-program.f8de2da6.png";